/// <amd-module name="Test/PassRateChartView/Actions/PassRateChartActions" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { Action } from "VSS/Reflux/Action";

export class PassRateChartActions {
    public updateConfigurationValuesAction: Action<CommonTypes.IReportConfiguration> = new Action<CommonTypes.IReportConfiguration>();
    public updatePassRateChartAction: Action<CommonTypes.ICardMetricsData> = new Action<CommonTypes.ICardMetricsData>();
    public onError = new Action<Error>();
}
